import { Fragment } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
} from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import {
  Technical,
  Links,
  LinkTypes,
  LinkStatuses,
  Infrastructures,
} from "../../../../Constant";
import { Link } from "react-router-dom";
import { PlusCircle } from "react-feather";
import TechnicalLinkStatusList from "./LinkStatus/List/TechnicalLinkStatusList";
import TechnicalLinkTypeList from "./LinkType/List/TechnicalLinkTypeList";
import TechnicalInfrastructureList from "./Infrastructure/List/TechnicalInfrastructureList";
import useLinkSettings from "./controller";
import TechnicalLinkList from "./Link/List/TechnicalLinkList";

const LinkSettings = () => {
  const {
    layoutURL,
    LINK_TYPE,
    LINK_STATUS,
    INFRASTRUCTURE,
    T_LINK,
    commissionTab,
    tabDisplayNames,
    handleTabClick,
  } = useLinkSettings();

  return (
    <Fragment>
      <Breadcrumbs
        parent={Technical}
        title={tabDisplayNames[commissionTab]}
        mainTitle={tabDisplayNames[commissionTab]}
      />
      <Container fluid={true}>
        <Row>
          <Col sm="12" xl="12" className="xl-100">
            <Card>
              <CardBody>
                <Row>
                  <Col md="6">{/*<H5>{GradeGroup}</H5>*/}</Col>
                  <Col md="6">
                    <div className="text-end file-content">
                      <Link
                        className="btn btn-primary ms-2"
                        style={{ color: "white" }}
                        to={`/technical/${commissionTab}/create/${layoutURL}`}
                      >
                        <PlusCircle /> New{" "}
                        {tabDisplayNames[commissionTab] || "Item"}
                      </Link>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col sm={"12"}>
                    <Nav className="border-tab nav-secondary nav-pills" tabs>
                      <NavItem>
                        <NavLink
                          href="#"
                          className={
                            commissionTab === `${LINK_TYPE}` ? "active" : ""
                          }
                          onClick={() => handleTabClick(`${LINK_TYPE}`)}
                        >
                          <i className="icofont icofont-files"></i>
                          {LinkTypes}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          href="#"
                          className={
                            commissionTab === `${LINK_STATUS}` ? "active" : ""
                          }
                          onClick={() => handleTabClick(`${LINK_STATUS}`)}
                        >
                          <i className="icofont icofont-files"></i>
                          {LinkStatuses}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          href="#"
                          className={
                            commissionTab === `${INFRASTRUCTURE}`
                              ? "active"
                              : ""
                          }
                          onClick={() => handleTabClick(`${INFRASTRUCTURE}`)}
                        >
                          <i className="icofont icofont-files"></i>
                          {Infrastructures}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          href="#"
                          className={
                            commissionTab === `${T_LINK}` ? "active" : ""
                          }
                          onClick={() => handleTabClick(`${T_LINK}`)}
                        >
                          <i className="icofont icofont-files"></i>
                          {Links}
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={commissionTab}>
                      {commissionTab === `${LINK_TYPE}` && (
                        <TechnicalLinkTypeList name={LINK_TYPE} />
                      )}
                      {commissionTab === `${LINK_STATUS}` && (
                        <TechnicalLinkStatusList name={LINK_STATUS} />
                      )}
                      {commissionTab === `${INFRASTRUCTURE}` && (
                        <TechnicalInfrastructureList name={INFRASTRUCTURE} />
                      )}
                      {commissionTab === `${T_LINK}` && (
                        <TechnicalLinkList name={T_LINK} />
                      )}
                    </TabContent>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default LinkSettings;
